import { all } from 'redux-saga/effects';
import PublicTemplatesSaga from './publicTemplates/saga';
import ProjectTemplatesSaga from './projectTemplates/saga';
import ScannedDocument from './scannedDocuments/saga';
import PreProcessedDocument from './preProcessedDocuments/saga';
import preRegisteredDocument from './preRegisteredDocuments/saga';
import noValidatedScannedDocument from './noValidatedScannedDocuments/saga';
import validatedScannedDocument from './validatedScannedDocuments/saga';
import prm from './PRMs/saga';
import nc from './NCs/saga';
import ThermalControlDevices from './thermalControl/devices/saga';
import ThermalControlMixtures from './thermalControl/mixtures/saga';
import ThermalControlMonitorings from './thermalControl/monitorings/saga';
import HoodedControlDevices from './hoodedControl/devices/saga';
import HoodedControlMonitorings from './hoodedControl/monitorings/saga';
import Auth from './auth/saga';
import Projects from './projects/saga';
import Users from './users/saga';
import CemexTracking from './cemexTracking/saga';
import DeliveryNotes from './deliveryNotes/saga';
import concreteBatch from './concreteBatch/saga';

export default function* rootSaga() {
  yield all([
    PublicTemplatesSaga(),
    ProjectTemplatesSaga(),
    ScannedDocument(),
    PreProcessedDocument(),
    preRegisteredDocument(),
    noValidatedScannedDocument(),
    validatedScannedDocument(),
    prm(),
    nc(),
    ThermalControlDevices(),
    ThermalControlMixtures(),
    ThermalControlMonitorings(),
    HoodedControlDevices(),
    HoodedControlMonitorings(),
    Auth(),
    Projects(),
    Users(),
    CemexTracking(),
    DeliveryNotes(),
    concreteBatch(),
  ]);
}
